<template>
  <v-container fluid grid-list-md>
    <v-layout align-center justify-center column fill-height>
        <h1>Progress</h1>
        <v-card width="80%" flat>
        <v-list two-line subheader>
            <v-list-tile
                v-for="item in getWords"
                :key="item.title"
                avatar
            >
                <v-list-tile-avatar>
                <v-progress-circular
                    :value="item.value"
                    color="purple"
                    ></v-progress-circular>
                </v-list-tile-avatar>

                <v-list-tile-content>
                <v-list-tile-title>{{ item.word }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.type }}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <span>Level {{item.srs}}</span>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
        </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { store } from "../store/store.js";

export default {
    data() {
        return {
            items: [
                {  word: 'Agus', type: 'Noun', srs: "2", value: 67},
                {  word: 'Bean', type: 'Noun', srs: "3", value: 100},
                {  word: 'Mac', type: 'Noun', srs: "1", value: 33}
            ],
            data2: []
        }
    },
    computed: {
        getWords: function () {
            var data = []
            //while (this.$store.getters.loading) {
            //    console.log("hi")
            //}
            var test1 = this.$store.getters.getCurrentLessonVocab
            var test2 = this.$store.getters.unstudiedVocab
            if (test2.length > 0) {
                //data.push(test1)
                //console.log("NEW")
                //console.log(data)
                for (var i = 0; i < 11; i++) {
                    var current = test1[i];
                    var wordSRS = this.$store.getters.wordSRS(current);
                    var wordValue = wordSRS * 33;
                    var wordPOS = current.partOfSpeech;
                    var POSstring = ''
                    if (wordPOS != null) {
                        if (wordPOS == 1) {
                            //Noun
                            POSstring = "Noun"
                        }
                        if (wordPOS == 2) {
                            //Adj
                            POSstring = "Adjective"
                        }
                        if (wordPOS == 3) {
                            //Verb
                            POSstring = "Verb"
                        }
                        if (wordPOS == 4) {
                            console.log("1")
                        }
                        if (wordPOS == 5) {
                            console.log("1")
                        }
                        if (wordPOS == 6) {
                            //Con
                            POSstring = "Conjunction"
                        }
                    }
                    var element = { word: current.emiWord, type: POSstring, srs: wordSRS, value: wordValue };
                    //console.log(element)
                    if (wordSRS > 0) {
                        data.push(element)
                    }
                }
                //console.log(data)
            }
            if (data.length != 0) {
                this.data2 = data;
            }
            return this.data2

        },
        test: function() {
            console.log("testing")
            return [
                {  word: 'Agus', type: 'Noun', srs: "2", value: 67},
                {  word: 'Bean', type: 'Noun', srs: "3", value: 100},
                {  word: 'Mac', type: 'Noun', srs: "1", value: 33}
            ]
        },
        test2: function() {
            console.log("HERE");
            var data = this.getWords;
            console.log(data);
            if (data.length != 0) {
                this.data2 = data;
                console.log(this.data2)
            }
            return this.data2;
        },
        progress: function() {
            return this.$store.getters.progressInfo
        }
    }
}
</script>



<style>
</style>